import { render, staticRenderFns } from "./cateoryimageSlider.vue?vue&type=template&id=4ae9b448&"
import script from "./cateoryimageSlider.vue?vue&type=script&lang=js&"
export * from "./cateoryimageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports